import { Button, Spinner } from '@design-system';
import { useTranslation } from 'next-i18next';

import { pathFor } from '../../../helpers/links';
import { IdentityVerificationCard } from './ui/IdentityVerificationCard';
import { SuccessMessage } from './ui/SuccessMessage';

export type SuccessStatus = 'confirming' | 'confirmed';

export type SuccessProps = {
  isAuction?: boolean;
  isPreorder: boolean;
  artistName: string;
  identityVerificationRequired?: boolean;
  numberOfDraws?: number;
  status?: SuccessStatus;
  winUpTo?: number;
  images: {
    id: string;
    src: string;
    alt: string;
  }[];
};

export const Success = ({
  artistName,
  identityVerificationRequired = false,
  images,
  isAuction = false,
  isPreorder = false,
  numberOfDraws,
  status = 'confirmed',
  winUpTo,
}: SuccessProps) => {
  const { t } = useTranslation('checkout');
  const copyKey = isAuction ? 'auction' : isPreorder ? 'preorder' : 'draw';

  if (status === 'confirming') {
    return (
      <div className="mt-6 flex w-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <SuccessMessage
      action={
        identityVerificationRequired ? (
          <IdentityVerificationCard />
        ) : (
          <Button
            as="a"
            fullWidth
            href={pathFor({ page: 'RELEASES_INDEX' })}
            label={t('success.discover')}
            variant="primary"
          />
        )
      }
      body={t(`success.${copyKey}.body`, {
        artistName,
        numberOfDraws,
        winUpTo,
      })}
      images={images}
      title={t(`success.${copyKey}.title`)}
    />
  );
};
